import { Platform, StyleSheet } from 'react-native'
import { DS } from '../../../../../../../design-system'
export const ButtonValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 'Clear', 0, 'Delete'] as const
export type ButtonValue = (typeof ButtonValues)[number]

interface PadButtonProps {
  text: ButtonValue
  onPress: (value: ButtonValue) => void
}

export const PadButton = ({ text, onPress }: PadButtonProps) => {
  return (
    <DS.Button variant="Large/Secondary" type="On Dark" onPress={() => onPress(text)} style={styles.container}>
      {text}
    </DS.Button>
  )
}

const styles = StyleSheet.create({
  container: {
    borderColor: 'lightgray',
    borderWidth: 1,
    borderRadius: 48,
    padding: Platform.OS === 'ios' ? 15 : 10,
    width: '32%'
  }
})
